import {createAction} from 'util/redux';
import {StTagTO} from 'generated/JavaTO';

const NAMESPACE = 'ST_TAG/'
export const stTagEnsureRefreshedAction = createAction(NAMESPACE + 'ensureFetched')
export const stTagFetchAllAction = createAction(NAMESPACE + 'fetchAll')
export const stTagResetAction = createAction<StTagTO[]>(NAMESPACE + 'reset')